import { VisitCounter } from "./VisitCounter";

import { Facebook, Instagram, Menu } from "lucide-react";
import { Sheet, SheetClose, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";


export const Logo = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" aria-hidden="true">
    <rect width="36" height="36" className="fill-mm-ink" />
    <path d="M6 26 Q18 4 30 26" fill="none" className="stroke-mm-gold" strokeWidth="2" />
    <text x="18" y="29" textAnchor="middle" fontFamily="Anton,Impact,sans-serif" fontSize="20" className="fill-mm-red">4</text>
    <path d="M13 11 L23 11" className="stroke-mm-blue" strokeWidth="2" />
  </svg>
);

export const INSTAGRAM_URL = "https://www.instagram.com/mm4s2026/";
export const FACEBOOK_URL = "https://www.facebook.com/mm44s2026";

const LINKS = [
  { href: "#lettre", label: "La lettre", id: "nav-lettre" },
  { href: "#france-avenir", label: "France Avenir", id: "nav-france-avenir" },
  { href: "#dette", label: "50 ans de dette", id: "nav-dette" },
  { href: "#business-plan", label: "Business Plan", id: "nav-bp" },
  { href: "#bd", label: "Huit cases", id: "nav-bd" },
  { href: "#chanson", label: "Chanson", id: "nav-chanson" },
  { href: "#notes", label: "Notes", id: "nav-notes" },
  { href: "#documents", label: "Documents", id: "nav-documents" },
];

export const Header = () => (
  <header className="sticky top-0 z-40 bg-mm-paper/95 backdrop-blur-md text-mm-ink border-b border-mm-ink/15">
    <VisitCounter />
    <nav className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4" aria-label="Principal">
      <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
        <Logo />
        <span className="disp text-2xl tracking-tight">MM4S</span>
      </a>
      <div className="hidden xl:flex gap-5 text-sm font-semibold">
        {LINKS.map((l) => (
          <a key={l.href} href={l.href} className="ulink" data-testid={l.id}>{l.label}</a>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook mm44s2026" data-testid="nav-facebook-link"
          className="hidden sm:inline-flex p-2 border-2 border-mm-ink hover:bg-mm-ink hover:text-mm-paper transition-colors">
          <Facebook className="w-5 h-5" />
        </a>
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram MM4S2026" data-testid="nav-instagram-link"
          className="hidden sm:inline-flex p-2 border-2 border-mm-ink hover:bg-mm-ink hover:text-mm-paper transition-colors">
          <Instagram className="w-5 h-5" />
        </a>
        <a href="#signer" data-testid="nav-signer-btn" className="bg-mm-red text-white px-5 py-2 text-sm font-bold hover:bg-mm-ink transition-colors">
          Signer
        </a>
        <MobileMenu />
      </div>
    </nav>
  </header>
);

const MOBILE_LINKS = [
  ...LINKS.slice(0, 2),
  { href: "#simulateur", label: "Simulateur", id: "nav-simulateur" },
  ...LINKS.slice(2, 4),
  { href: "#regles", label: "Règles & machine", id: "nav-regles" },
  ...LINKS.slice(4),
  { href: "#signer", label: "Signer la lettre", id: "nav-signer" },
];

const MobileMenu = () => (
  <Sheet>
    <SheetTrigger asChild>
      <button type="button" aria-label="Ouvrir le menu" data-testid="mobile-menu-btn" className="xl:hidden p-2 border-2 border-mm-ink hover:bg-mm-ink hover:text-mm-paper transition-colors">
        <Menu className="w-5 h-5" />
      </button>
    </SheetTrigger>
    <SheetContent side="right" className="bg-mm-paper text-mm-ink w-[85%] border-l-4 border-mm-red" data-testid="mobile-menu">
      <SheetTitle className="disp text-2xl text-mm-ink">MM4S · Menu</SheetTitle>
      <ul className="mt-8 divide-y divide-mm-ink/20 border-y border-mm-ink/20">
        {MOBILE_LINKS.map((l) => (
          <li key={l.href}>
            <SheetClose asChild>
              <a href={l.href} data-testid={`mobile-${l.id}`} className="disp text-2xl block py-3 hover:text-mm-red transition-colors">{l.label}</a>
            </SheetClose>
          </li>
        ))}
      </ul>
      <div className="flex gap-3 mt-8">
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-facebook-link" className="inline-flex items-center gap-2 border-2 border-mm-ink px-3 py-2 font-bold"><Facebook className="w-5 h-5" /> Facebook</a>
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-instagram-link" className="inline-flex items-center gap-2 border-2 border-mm-ink px-3 py-2 font-bold"><Instagram className="w-5 h-5" /> Instagram</a>
      </div>
      <p className="mm-lab text-mm-golddark mt-8">Scolarité • Santé • Sécurité • Solidarité</p>
    </SheetContent>
  </Sheet>
);
